module.exports = __webpack_public_path__ + "img/photo-08.b6c4539a.webp";